"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9928],{

/***/ 31256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DownArrowIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (props === null || props === void 0 ? void 0 : props.width) || "20px",
        height: (props === null || props === void 0 ? void 0 : props.height) || "20px",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "clip-path": "url(#clip0_3665_9925)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.175 7.15839L10 10.9751L13.825 7.15839L15 8.33339L10 13.3334L5 8.33339L6.175 7.15839Z",
                    fill: props === null || props === void 0 ? void 0 : props.color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3665_9925",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: (props === null || props === void 0 ? void 0 : props.width) || "20px",
                        height: (props === null || props === void 0 ? void 0 : props.height) || "20px",
                        fill: props === null || props === void 0 ? void 0 : props.color,
                        transform: "translate(20) rotate(90)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 42383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RightArrowIconTransparent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var RightArrowIconTransparent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (props === null || props === void 0 ? void 0 : props.width) || "24px",
        height: (props === null || props === void 0 ? void 0 : props.width) || "24px",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "clip-path": "url(#clip0_3272_805)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z",
                    fill: props === null || props === void 0 ? void 0 : props.color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3272_805",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: props === null || props === void 0 ? void 0 : props.color
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/assets/svgExports/DownArrowIcon.js
var DownArrowIcon = __webpack_require__(31256);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(20901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 14.5rem;\n  flex-direction: column;\n  top: 32px;\n  z-index: 5;\n  max-height: 200px;\n  overflow-y: auto;\n\n  & div {\n    padding: 0.75rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid\n      ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DropwdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropwdownContainer",
    componentId: "sc-a94810ad-0"
})(_templateObject(), function(props) {
    return (0,common/* hexToRgba */.a7)("".concat(props.themeConfig.borderColor), 0.1);
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.js



var Dropdown = function(param) {
    var dropDownData = param.dropDownData, handler = param.handler, rightPx = param.rightPx, logoSize = param.logoSize, themeConfig = param.themeConfig, handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropwdownContainer, {
        logoSize: logoSize,
        className: "dropdown-container",
        style: {
            right: rightPx || ""
        },
        themeConfig: themeConfig,
        children: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.map(function(data) {
            var ref;
            return (data === null || data === void 0 ? void 0 : (ref = data.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    handler(data);
                    handleClose && handleClose();
                },
                style: {
                    justifyContent: rightPx ? "flex-end" : "flex-start",
                    textAlign: rightPx ? "right" : "left"
                },
                className: "nav-links",
                children: [
                    " ",
                    data === null || data === void 0 ? void 0 : data.name,
                    " ",
                    (data === null || data === void 0 ? void 0 : data.isDropdown) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {
                        color: "black"
                    }),
                    " "
                ]
            }, data === null || data === void 0 ? void 0 : data.id) : null;
        })
    });
};
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);


/***/ }),

/***/ 99928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer3_Footer3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(20901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer3/Footer3.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 10;\n  & > .top-section {\n    padding: 2.5rem 4rem;\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n  }\n  & .top-section.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n  & .top-section.bg_type_image::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n  & > .top-section.bg_type_solid {\n    background: ",
        ";\n  }\n  & > .top-section .top-first-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    z-index: 12;\n  }\n  & > .top-section .top-first-section p {\n    z-index: 12;\n    margin: 0;\n    text-align: center;\n    font-size: 0.75rem;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  & > .top-section .top-first-section .nav-links-container {\n    display: flex;\n    justify-content: center;\n    gap: 1.5rem;\n    z-index: 11;\n  }\n  & > .top-section .top-first-section .nav-links-container .nav-links {\n    z-index: 12;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    position: relative;\n    font-size: 1rem;\n    font-weight: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n  }\n  & > .top-section .top-first-section .nav-links-container .nav-links svg path {\n    fill: currentColor;\n  }\n  &\n    > .top-section\n    .top-first-section\n    .nav-links-container\n    .nav-links\n    .dropdown-container {\n    background: ",
        ";\n    z-index: 12;\n    top: 28px;\n    width: 15.5rem;\n  }\n  & > .top-section .footer-description {\n    z-index: 11;\n    font-size: 1rem;\n    font-weight: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    line-height: 22px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n    overflow-wrap: break-word;\n    overflow-wrap: anywhere;\n  }\n  & > hr {\n    max-width: 100%;\n    background-color: ",
        ";\n    opacity: 0.6;\n    margin: 0;\n  }\n  & > .bottom-section .footerDesktopContainer {\n    padding: 2.5rem 4rem;\n    background: ",
        " !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 10;\n  & > .top-section {\n    padding: 2.5rem 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  & > .top-section.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n  & > .top-section.bg_type_image::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n  & > .top-section.bg_type_solid {\n    background: ",
        ";\n  }\n  & > .top-section .top-first-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    position: relative;\n    z-index: 10;\n  }\n  & > .top-section .top-first-section p {\n    margin: 0;\n    text-align: center;\n    font-size: 0.75rem;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > .top-section .top-first-section .nav-links-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n    z-index: 11;\n  }\n  & > .top-section .top-first-section .nav-links-container .nav-links {\n    display: flex;\n    flex-direction: column;\n    z-index: 11;\n  }\n\n  .nav-links .links {\n    z-index: 12;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    font-size: 1rem;\n    position: relative;\n    font-weight: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n  }\n  &\n    .top-section\n    .top-first-section\n    .nav-links-container\n    .nav-links\n    .dropdown-container\n    div {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    z-index: 14;\n  }\n  & > .top-section .top-first-section .nav-links-container .nav-links svg path {\n    fill: currentColor;\n  }\n\n  &\n    > .top-section\n    .top-first-section\n    .nav-links-container\n    .nav-links\n    .dropdown-container {\n    background: ",
        ";\n    z-index: 12;\n    position: relative;\n    top: 0;\n    width: 100%;\n  }\n  & > .top-section .footer-description {\n    z-index: 11;\n    font-size: 1rem;\n    font-weight: ",
        ";\n    font-family: ",
        ";\n    color: ",
        ";\n    line-height: 22px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n    overflow-wrap: break-word;\n    overflow-wrap: anywhere;\n  }\n  & > hr {\n    max-width: 100%;\n    background-color: ",
        ";\n    opacity: 0.6;\n    margin: 0;\n  }\n  & > .bottom-section > div {\n    padding: 0rem !important;\n    background: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterContainer",
    componentId: "sc-73db78a7-0"
})(_templateObject(), function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var FooterDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterDesktopContainer",
    componentId: "sc-73db78a7-1"
})(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, utils_common/* FOOTER_OPACITY */.he, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
});
var FooterMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FooterMobileContainer",
    componentId: "sc-73db78a7-2"
})(_templateObject2(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* FOOTER_OPACITY */.he, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonSecondary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.themeBackground) === null || ref === void 0 ? void 0 : ref.backgroundColor;
});

// EXTERNAL MODULE: ./src/assets/svgExports/DownArrowIcon.js
var DownArrowIcon = __webpack_require__(31256);
// EXTERNAL MODULE: ./src/assets/svgExports/RightArrowIconTransparent.js
var RightArrowIconTransparent = __webpack_require__(42383);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(10502);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/Footer/utils/commonGetterFunction.js
var commonGetterFunction = __webpack_require__(5790);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer2/Footer2.js + 3 modules
var Footer2 = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer1/Footer1.js + 3 modules
var Footer1 = __webpack_require__(66035);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer3/Components/FooterDesktop.js










var FooterDesktop = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var footerState = props.footerState, store = props.store, propStyle = props.propStyle, headerLinks = props.headerLinks;
    var ref6 = (0,react.useState)({
        openDropDown: false,
        activeLink: ""
    }), dropDownActive = ref6[0], setDropDownActive = ref6[1];
    var dropdownRef = (0,react.useRef)(null);
    var parentLinkRef = (0,react.useRef)(null);
    var handleNavInteraction = function(data) {
        if (data.actions.type === 5) {
            if (data.actions.handler === "") {
                setDropDownActive(function(prevState) {
                    return (prevState === null || prevState === void 0 ? void 0 : prevState.activeLink) === (data === null || data === void 0 ? void 0 : data.id) ? {
                        openDropDown: false,
                        activeLink: ""
                    } : {
                        openDropDown: true,
                        activeLink: data === null || data === void 0 ? void 0 : data.id
                    };
                });
            }
        } else {
            (0,btnUtils/* btnActionHandler */.c)(data === null || data === void 0 ? void 0 : data.actions);
        }
    };
    var handleClickOutside = function(event) {
        if (parentLinkRef.current && !parentLinkRef.current.contains(event.target) && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropDownActive({
                openDropDown: false,
                activeLink: ""
            });
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var getHandler = function(data) {
        return handleNavInteraction(data);
    };
    var getNavLinksDesktop = function(navLinkData) {
        return navLinkData === null || navLinkData === void 0 ? void 0 : navLinkData.map(function(nav) {
            var ref, ref1, ref2, ref3, ref4;
            return (nav === null || nav === void 0 ? void 0 : (ref = nav.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-links",
                onClick: function() {
                    return getHandler(nav);
                },
                ref: parentLinkRef,
                children: [
                    nav === null || nav === void 0 ? void 0 : nav.name,
                    " ",
                    (nav === null || nav === void 0 ? void 0 : (ref1 = nav.actions) === null || ref1 === void 0 ? void 0 : ref1.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref2 = nav.children) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {
                        color: "black"
                    }),
                    " ",
                    (nav === null || nav === void 0 ? void 0 : (ref3 = nav.actions) === null || ref3 === void 0 ? void 0 : ref3.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref4 = nav.children) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && (dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        ref: dropdownRef,
                        dropDownData: nav === null || nav === void 0 ? void 0 : nav.children,
                        handler: getHandler,
                        width: "20px",
                        height: "20px",
                        themeConfig: propStyle
                    })
                ]
            }, nav === null || nav === void 0 ? void 0 : nav.id) : null;
        });
    };
    var getNavLinksMobile = function(navLinkData) {
        return navLinkData === null || navLinkData === void 0 ? void 0 : navLinkData.map(function(nav) {
            var ref, ref1, ref2, ref3, ref4;
            return (nav === null || nav === void 0 ? void 0 : (ref = nav.name) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-links",
                onClick: function() {
                    return getHandler(nav);
                },
                ref: parentLinkRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "links",
                        children: [
                            " ",
                            nav === null || nav === void 0 ? void 0 : nav.name,
                            " ",
                            (nav === null || nav === void 0 ? void 0 : (ref1 = nav.actions) === null || ref1 === void 0 ? void 0 : ref1.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref2 = nav.children) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && ((dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DownArrowIcon/* DownArrowIcon */.G, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIconTransparent/* RightArrowIconTransparent */.I, {
                                color: "black"
                            })),
                            " "
                        ]
                    }),
                    (nav === null || nav === void 0 ? void 0 : (ref3 = nav.actions) === null || ref3 === void 0 ? void 0 : ref3.type) === 5 && (nav === null || nav === void 0 ? void 0 : (ref4 = nav.children) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && (dropDownActive === null || dropDownActive === void 0 ? void 0 : dropDownActive.activeLink) === (nav === null || nav === void 0 ? void 0 : nav.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        ref: dropdownRef,
                        dropDownData: nav === null || nav === void 0 ? void 0 : nav.children,
                        handler: getHandler,
                        width: "20px",
                        height: "20px",
                        themeConfig: propStyle
                    })
                ]
            }, nav === null || nav === void 0 ? void 0 : nav.id) : null;
        });
    };
    var ref7 = (0,react.useState)(true), IS_DESKTOP = ref7[0], setIS_DESKTOP = ref7[1];
    var checkWindowSize = function() {
        if (true) {
            var isMobile = window.innerWidth < 768; // You can adjust this threshold
            setIS_DESKTOP(!isMobile);
        }
    };
    (0,react.useEffect)(function() {
        // Check window size on component mount
        checkWindowSize();
        // Add event listener for window resize only on the client side
        var handleResize = function() {
            checkWindowSize();
        };
        if (true) {
            window.addEventListener("resize", handleResize);
            // Cleanup the event listener on component unmount
            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    return IS_DESKTOP ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterDesktopContainer, {
        themeBackground: propStyle,
        className: "modernFooter",
        propsBackground: footerState === null || footerState === void 0 ? void 0 : (ref = footerState.media) === null || ref === void 0 ? void 0 : ref.background,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top-section bg_type_".concat(footerState === null || footerState === void 0 ? void 0 : (ref1 = footerState.media) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.background) === null || ref2 === void 0 ? void 0 : ref2.type),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-first-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Quick Links"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-links-container",
                                children: getNavLinksDesktop(headerLinks)
                            })
                        ]
                    }),
                    (0,commonGetterFunction/* getDescription */.Eb)(footerState)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bottom-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer2["default"], {
                    footerState: footerState,
                    store: store,
                    propStyle: propStyle,
                    isAlreadyTransformed: true
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterMobileContainer, {
        themeBackground: propStyle,
        className: "modernFooter",
        propsBackground: footerState === null || footerState === void 0 ? void 0 : (ref3 = footerState.media) === null || ref3 === void 0 ? void 0 : ref3.background,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top-section bg_type_".concat(footerState === null || footerState === void 0 ? void 0 : (ref4 = footerState.media) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.type),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-first-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Quick Links"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-links-container",
                                children: getNavLinksMobile(headerLinks)
                            })
                        ]
                    }),
                    (0,commonGetterFunction/* getDescription */.Eb)(footerState)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bottom-section",
                children: IS_DESKTOP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer2["default"], {
                    footerState: footerState,
                    store: store,
                    propStyle: propStyle,
                    isAlreadyTransformed: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1["default"], {
                    footerState: footerState,
                    store: store,
                    propStyle: propStyle,
                    isAlreadyTransformed: true
                })
            })
        ]
    });
};
/* harmony default export */ var Components_FooterDesktop = (FooterDesktop);

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/Footer/Footer3/Footer3.js








var Footer3 = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), footerState = ref9[0], setFooterState = ref9[1];
    (0,react.useEffect)(function() {
        var ref;
        setFooterState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children));
    }, [
        props
    ]);
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref10 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref10[0], setPropStyle = ref10[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template
    ]);
    var ref11 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)((ref5 = storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : ref4.Header[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.config) === null || ref6 === void 0 ? void 0 : ref6.children)), headerLinks = ref11[0], setHeaderLinks = ref11[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        id: "Footer3",
        propsBackground: footerState === null || footerState === void 0 ? void 0 : (ref7 = footerState.media) === null || ref7 === void 0 ? void 0 : ref7.background,
        themeBackground: propStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_FooterDesktop, {
            store: storeData,
            footerState: footerState,
            setFooterState: setFooterState,
            propStyle: propStyle,
            headerLinks: headerLinks === null || headerLinks === void 0 ? void 0 : (ref8 = headerLinks.nav_links) === null || ref8 === void 0 ? void 0 : ref8.content,
            setHeaderLinks: setHeaderLinks
        })
    });
};
/* harmony default export */ var Footer3_Footer3 = (Footer3);


/***/ })

}]);